module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__wrap--bg cmp-modal",
    attrs: {
      "id": "introductionEx2"
    }
  }, [_c('div', {
    staticClass: "modal-wrap-container modal-wd1020"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("자기소개서 예시")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body-container ht-full"
  }, [_c('div', {
    staticClass: "box-type bg-primary block text-l mt-40"
  }, [_vm._v("\n        ※ 예시용 자기소개서는 백지에 첫 문장을 작성하시기 어려운 분들을 위한 참고용으로 가상의 조건을 설정해 작성된 내용이오니, "), _c('span', {
    staticClass: "color-hilight"
  }, [_vm._v("반드시 참고용으로만 확인해")]), _vm._v(" 주세요\n      ")]), _vm._v(" "), _c('h3', {
    staticClass: "section-title color-primary mt-40"
  }, [_vm._v("자기소개서 예시 (요양보호사, 중장년 남성, 신규 취업용)")]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "table-body-only"
  }, [_c('caption', [_vm._v("자기소개서 예시 (요양보호사, 중장년 남성, 신규 취업용) 표")]), _vm._v(" "), _c('colgroup', [_c('col')]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('div', {
    staticClass: "cover-letter-section"
  }, [_c('h4', [_vm._v("1. 성장 배경 및 성격")]), _vm._v(" "), _c('p', [_vm._v("오랜 시간 직장생활을 하며 성실함, 책임감, 그리고 인간관계를 중시하는 태도를 배워왔습니다. 특히 주변 사람들을 배려하고 살피는 습관은 가족은 물론, 직장에서도 긍정적인 평가를 받아왔습니다.\n                    "), _c('br'), _vm._v("젊은 시절에는 조직의 일원으로서 목표를 향해 바쁘게 달려왔지만, 이제는 누군가를 돌보고 따뜻하게 보듬는 일을 통해 삶의 보람을 느끼고자 요양보호사라는 직업에 도전하게 되었습니다.\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "cover-letter-section"
  }, [_c('h4', [_vm._v("2. 요양보호사에 관심을 갖게 된 계기")]), _vm._v(" "), _c('p', [_vm._v("부모님을 직접 모시며 노년기의 돌봄이 단순한 노동이 아니라 진심과 공감이 필요한 일임을 깊이 체감했습니다. 특히 거동이 불편하거나 정서적으로 외로운 어르신들이 많다는 현실을 보면서, 직접 도움이 되는 일을 하고 싶다는 마음이 커졌습니다.\n                    "), _c('br'), _vm._v("이후 요양보호사 자격증을 취득하고 관련 교육을 이수하며, 전문성과 실천력을 갖추기 위해 준비해왔습니다.\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "cover-letter-section"
  }, [_c('h4', [_vm._v("3. 직무 관련 강점 및 준비")]), _vm._v(" "), _c('p', [_vm._v("비록 현장 경험은 부족하지만, 오랜 회사생활을 통해 얻은 책임감, 커뮤니케이션 능력, 기록 정리 습관 등은 요양 현장에서도 충분히 활용될 수 있다고 생각합니다.\n                    "), _c('br'), _vm._v("또한 교육과 실습을 통해 기본적인 신체 활동 지원, 위생 관리, 정서적 교감 방법 등을 익혔으며, 어르신 한 분 한 분을 가족처럼 대하겠다는 다짐을 갖고 있습니다.\n                    "), _c('br'), _vm._v("몸을 움직이는 일을 마다하지 않고, 작은 일에도 의미를 부여할 줄 아는 점이 저의 강점입니다.\n                  ")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-md mo-button-full button-wid150",
    attrs: {
      "type": "button",
      "onclick": "closeModal(event)"
    }
  }, [_vm._v("\n        닫기\n      ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-close only-icon close-modal",
    attrs: {
      "type": "button",
      "aria-label": "닫기",
      "onclick": "closeModal(event)",
      "title": "닫기"
    }
  }, [_c('i', {
    staticClass: "ico ico-x-bl"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d39610e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/resume/IntroductionEx2.vue
// module id = 1342
// module chunks = 6